import React from 'react';
import HeroCollage from './components/HeroCollage';
import DescubreNuestrosCursos from './components/DescubreNuestrosCursos';
import OfertaEducativa from './components/OfertaEducativa';
import CampusCard from './components/CampusCard';
import PreFooter from './components/PreFooter';
import VideoSection from './components/VideoSection';
import MisionVision from '../about/components/MisionVision';
import MomentosCarousel from '../about/components/MomentosCarousel';
import { CAMPUS_LIST } from '../../data/campus';

const LandingPage = () => {
  return (
    <div className="bg-white">
      <HeroCollage />
      <DescubreNuestrosCursos />
      <VideoSection />
      <OfertaEducativa />

      {/* Sección campus */}
      <section id="campusBuga" className="bg-gray-50 py-20 px-4">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-14">
            <p className="text-gray-400 uppercase tracking-[0.3em] text-xs mb-3">Nuestras sedes</p>
            <h2 className="text-4xl md:text-6xl font-black text-black">Nuestros Campus</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {CAMPUS_LIST.map((campus) => (
              <CampusCard key={campus.slug} campus={campus} />
            ))}
          </div>
        </div>
      </section>

      <MisionVision />
      <MomentosCarousel />

      <PreFooter />

      <a
        href="https://wa.me/+525521048568"
        target="_blank"
        rel="noreferrer"
        className="fixed bottom-6 left-6 z-50 w-[81px] md:w-[125px] h-auto hover:scale-110 transition-all duration-300 drop-shadow-xl"
        aria-label="WhatsApp"
      >
        <img src={require('../../static/images/brand/logo-whatsapp.webp')} alt="WhatsApp" className="w-full h-full" />
      </a>
    </div>
  );
};

export default LandingPage;
